import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CheckboxInput from "components/Input/CheckboxInput/CheckboxInput";
import Datepicker from "components/Input/Datepicker/Datepicker";
import Selection from "components/Input/Selection/Selection";
import s from "./ChangeAllContent.module.scss";
import statusOptions from "utils/statusOptions/StatusOptions.jsx";

const ChangeAllContent = ({
  handleInput,
  changeAllDialogData,
  error,
  checkBoxFields,
  setCheckBoxFields,
}) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const updateBankAccountOnChange = (e) => {
    handleInput(e?.target?.checked, "updateBankAccount");
  };

  const updateStatusOnChange = (e, field) => {
    setCheckBoxFields({ ...checkBoxFields, [field]: e.target.checked });
    // Reset the planStatus or settleDate if the checkbox is unchecked
    if (!e.target.checked)
      handleInput(
        "",
        field === "isPlanStatusChecked" ? "planStatus" : "settleDate",
      );
  };

  const settleDateOnChange = (e, type) => {
    const rawDate = JSON.parse(JSON.stringify(e));
    const date = moment(rawDate).isValid()
      ? moment(rawDate).format("YYYY-MM-DD")
      : e !== null
        ? ""
        : null;
    if (type === "start") {
      handleInput(date, "settleDate");
    }
  };
  const settleDateOnFocus = () => {
    setFocus({ settleDate: true });
  };
  const settleDateOnBlur = () => {
    setFocus({ settleDate: false });
  };

  const textInputOnchange = (e, field) => {
    handleInput(e?.target?.value, field);
  };
  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };
  const textInputOnBlur = (field) => {
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <div className={s.bankAccountContainer}>
        <CheckboxInput
          label={t(
            "page.finance.settlement.plan.all.change.all.function.dialog.content.1",
          )}
          oncheckFn={(e) => updateBankAccountOnChange(e)}
          checked={changeAllDialogData.updateBankAccount}
        />
      </div>
      <div>
        <CheckboxInput
          label={t(
            "page.finance.settlement.plan.all.change.all.function.plan.status",
          )}
          oncheckFn={(e) => updateStatusOnChange(e, "isPlanStatusChecked")}
          checked={checkBoxFields.isPlanStatusChecked}
        />
        <Selection
          options={statusOptions(["APPROVED", "WAITING", "REJECTED"])}
          disabled={!checkBoxFields.isPlanStatusChecked}
          selectionValue={changeAllDialogData.planStatus}
          onchangeFn={(e) => textInputOnchange(e, "planStatus")}
          onfocusFn={() => textInputOnFocus("planStatus")}
          onblurFn={() => textInputOnBlur("planStatus")}
          sxParams={{
            selectionFocus: focus.planStatus,
            selectionError: error.planStatus,
          }}
          errorMessage={t(
            "page.finance.settlement.plan.all.change.all.function.error.message.3",
          )}
        />
      </div>

      <div>
        <CheckboxInput
          label={t(
            "page.finance.settlement.plan.all.change.all.function.dialog.content.2",
          )}
          oncheckFn={(e) => updateStatusOnChange(e, "isSettleDateChecked")}
          checked={checkBoxFields.isSettleDateChecked}
        />
        <Datepicker
          type="start"
          disabled={!checkBoxFields.isSettleDateChecked}
          value={changeAllDialogData.settleDate}
          onchangeFn={settleDateOnChange}
          onfocusFn={settleDateOnFocus}
          onblurFn={settleDateOnBlur}
          sxParams={{
            datepickerFocus: focus.settleDate,
            datepickerError: error.settleDate,
          }}
          errorMessage={t(
            "page.finance.settlement.plan.all.change.all.function.error.message.1",
          )}
        />
      </div>
    </div>
  );
};

export default React.memo(ChangeAllContent);
